"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostLoginActionNameEnum = void 0;
var PostLoginActionNameEnum;
(function (PostLoginActionNameEnum) {
    PostLoginActionNameEnum["OpenCashier"] = "OpenCashier";
    PostLoginActionNameEnum["OpenCashierUploadDocument"] = "OpenCashierUploadDocument";
    PostLoginActionNameEnum["UploadDocuments"] = "UploadDocuments";
    PostLoginActionNameEnum["OMGGetWaitingMessages"] = "OMG-GetWaitingMessages";
    PostLoginActionNameEnum["StartFavouriteSportsFlow"] = "StartFavouriteSportsFlow";
    PostLoginActionNameEnum["ShowAccountSummaryPage"] = "ShowAccountSummaryPage";
    PostLoginActionNameEnum["OpenLoginMessage"] = "OpenLoginMessage";
    PostLoginActionNameEnum["ShowKYC"] = "ShowKYC";
    PostLoginActionNameEnum["SetInitGeolocationFlow"] = "SetInitGeolocationFlow";
    PostLoginActionNameEnum["InitGeolocationFlow"] = "InitGeolocationFlow";
    PostLoginActionNameEnum["CheckForPendingIdentityVerification"] = "CheckForPendingIdentityVerification";
    PostLoginActionNameEnum["ActivityHistory"] = "ActivityHistory";
    PostLoginActionNameEnum["ShowPlayerWinLoss"] = "ShowPlayerWinLoss";
    PostLoginActionNameEnum["CheckIfLoginNotificationRequired"] = "CheckIfLoginNotificationRequired";
    PostLoginActionNameEnum["GetPersonalLimits"] = "GetPersonalLimits";
    PostLoginActionNameEnum["OpenControlCenterFull"] = "OpenControlCenterFull";
    PostLoginActionNameEnum["ForceBrand"] = "ForceBrand";
    PostLoginActionNameEnum["ShowOnboarding"] = "ShowOnboarding";
})(PostLoginActionNameEnum || (exports.PostLoginActionNameEnum = PostLoginActionNameEnum = {}));
//# sourceMappingURL=post-login.channel.interfaces.js.map